// GlobalErrorContext.js
import PropTypes from 'prop-types'
import React, {createContext, useState, useContext} from 'react'

const GlobalErrorContext = createContext()

export const GlobalErrorProvider = ({children}) => {
    const [globalErrors, setGlobalErrors] = useState([])

    const addError = (errorId) => {
        setGlobalErrors((prevErrors) => {
            if (!prevErrors.find((err) => err.id === errorId)) {
                return [...prevErrors, {id: errorId}]
            }
            return prevErrors
        })
    }

    const removeError = (errorId) => {
        setGlobalErrors((prevErrors) => prevErrors.filter((err) => err.id !== errorId))
    }

    const hasGlobalError = globalErrors.length > 0
    return (
        <GlobalErrorContext.Provider value={{addError, removeError, hasGlobalError}}>
            {children}
        </GlobalErrorContext.Provider>
    )
}

GlobalErrorProvider.propTypes = {
    children: PropTypes.node
}
export const useGlobalError = () => useContext(GlobalErrorContext)
